// @ts-strict-ignore
import {Component} from 'panel';

import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {initMutiny, optInMutiny, optOutMutiny} from 'common/util/mutiny';
import {initOptimizely, optInOptimizely, optOutOptimizely} from 'common/util/optimizely';
import {panel2react} from 'common/util/react';
import {setOptState} from 'media/js/gdpr/opt';

import {template} from './template';
import css from './index.inline.styl';

export interface CPRAPreferencesState {
  optStatus: `in` | `out`;
}

export class CPRAPreferences extends Component<CPRAPreferencesState> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
      defaultState: {
        optStatus: null,
      },
      helpers: {
        handleSwitchChange: async (ev: CustomEvent) => {
          const optStatus = ev.detail.selected;
          const trackingResponse = await setOptState(optStatus, `tracking`);
          const storageResponse = await setOptState(optStatus, `storage`);
          if (trackingResponse.success && storageResponse.success) {
            addToast({type: ToastType.SUCCESS, message: `CPRA preferences updated`});
            this.update({optStatus});
            if (optStatus === `out`) {
              optOutMutiny();
              optOutOptimizely();
            } else {
              optInMutiny();
              optInOptimizely();
            }
          } else {
            console.error({trackingResponse, storageResponse});
            addToast({type: ToastType.ERROR, message: `Something went wrong updating preferences`});
          }
        },
      },
    };
  }

  async connectedCallback() {
    super.connectedCallback();
    await window.gdprData.waitUntilReady();
    this.updateGdprData(window.gdprData);
    window.gdprData.registerOnUpdateCallback(this.updateGdprData.bind(this));
    initMutiny();
    initOptimizely();
  }

  updateGdprData({allowStorage, allowTracking}) {
    // CPRA requires that both storage + trackers are blocked. A user is only optedout to us "selling data" if they block both cookies and trackers.
    // Therefore if either is set, we consider them to be optedIn.
    const optStatus = allowStorage || allowTracking ? `in` : `out`;
    this.update({optStatus});
  }
}

customElements.define(`mp-cpra-preferences`, CPRAPreferences);
export const CPRAPreferencesEl = defineAndMakeJsxFactory(`mp-cpra-preferences`, CPRAPreferences);
export const CPRAPreferencesReact = panel2react(`mp-cpra-preferences`, CPRAPreferences);
